import React from 'react';
import './Filter_input.css'

const Filter_input = (props) => {
    return ( 
        <div className='filter_input_div1'>
            <h6 className='filter_input_text'>{props.text}</h6>
            <input className='filter_input'></input>
        </div>
     );
}
 
export default Filter_input;